module.exports = __webpack_public_path__ + "static/img/stop-star.7c8d3f93.png";